(function (apiUrl) {
    const showTradeIn = (e) => {
        if (!e.isApplicableForTradeIn) return;

        if (typeof CsnInsightsEventTracker !== 'undefined' && typeof CsnInsightsEventTracker.sendClick === 'function') {
            CsnInsightsEventTracker.sendEvent(CsnInsights.metaData, "tradein-popup", "tradein-popup-attempt-desktop", "click");
        }

        var url = `/postenquiry?driver_crossell=postenquiry-tradein-popup-desktop&leadid=${e.leadId}&enquirypostcode=${e.postcode}&sellertype=dealer`;

        $.colorbox({
                href: url,
                iframe: true,
                inline: false,
                width: 900,
                height: 700,
                opacity: 0.95,
                fixed: true,
                reposition: true,
                fastIframe: false
            }
        );
    };

    $(function() {
        var isLoaded = false;

        function loadPreApprovalPostEnquiry({detail}) {
            if (isLoaded) return;
            isLoaded = true;

            const url = `${apiUrl}?leadId=${detail.leadId}&itemId=${detail.itemId}`;

            fetch(url)
                .then((r) => {
                    if (r.ok) return r.text();
                    throw new Error(`${r.status} ${r.statusText}`);
                })
                .then((r) => {
                    if (!r) {
                        showTradeIn(detail);
                        return;
                    }

                    const enquiryForms = $(".enquiry-form");

                    enquiryForms.each(function(i) {
                        $(this).addClass("pb-1");
                    });

                    const elements = $("[data-toggle=finance-pre-approval]");
                    elements.each(function(i) {
                        $(this).html(r);
                        $(this).slideDown();
                    });
                })
                .catch(error => console.error({error}));
        }

        var ele = $(".enquiry-form")[0];
        if (ele != null) {
            ele.addEventListener("enquiry:post-enquiry", loadPreApprovalPostEnquiry);
        }
    });
})(window.finance_pre_approval_api_url);